'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export default function SafeHydrate(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  const [hydrated, setHydrated] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setHydrated(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  return hydrated ? children : null;
}